<!--
 * @Description: 文章模板页
 * @Author: Fore-Zhang
 * @Date: 2021-01-12 01:14:40
 * @LastEditTime: 2021-01-16 20:16:22
-->

<template>
  <div id="article" @touchmove="articleTouchMove">
    d
    <div id="TopBTCotainer">
      <img
        id="TopBT1"
        class="animated"
        :class="{rubberBand:bt1Animate}"
        @click="returnPage()"
        src="../assets/article_top_bt1.png"
      />
      <!--      <img id="TopBT2" @click="showTopMenu=!showTopMenu" src="../assets/article_top_bt2.png">-->
      <img
        id="TopBT3"
        class="animated heartBeat"
        @click="sharePageShow = true"
        src="../assets/top_share_bt.png"
      />
      <img id="TopBT4" @click="viewClass(0)" src="../assets/top_main_bt.png" />
    </div>
    <!--    <transition enter-active-class="animated bounceInDown" leave-active-class="animated bounceOutUp">-->
    <!--      <div id="TopMenu" v-if="showTopMenu">-->
    <!--        <img id="TopMenuImg" src="../assets/TopMenuImg.png">-->
    <!--        <div id='shareClickDiv' @click="sharePageShow=true"></div>-->
    <!--        <div id='retrunClickDiv' @click="viewClass(0)"></div>-->
    <!--      </div>-->
    <!--    </transition>-->
    <div
      id="articleScroller"
      :style="ScrollerStyle"
      @touchstart="mainTouchStart($event)"
      @touchend="mainTouchEnd($event)"
    >
      <div id="ArticleContainer">
        <ArticleTopBanner />
        <div id="ContentCotainer">
          <ArticleTitle />
          <component :is="ArticleContent" />
          <MoreArticles />
        </div>
      </div>
    </div>
    <div id="shareMasking" v-if="sharePageShow" @click="sharePageShow = false">
      <img src="../assets/share.png" style="width: 100%" />
    </div>
    <viewImage v-if="viewImageSrc != ''" />
  </div>
</template>
<script>
import pageStackStore from "../store/pageStackStore";
import store from "../store";

import ArticleTopBanner from "./ArticleTopBanner";
import MoreArticles from "./MoreArticles";
import ArticleTitle from "./ArticleTitle";
import viewImage from "./viewImage";

export default {
  name: "Article",
  store,
  components: {
    ArticleTopBanner,
    ArticleTitle,
    MoreArticles,
    viewImage,
  },
  data() {
    return {
      bt1Animate:true,
      sharePageShow: false,
      showTopMenu: false,
      scroller: 0,
      touch: { x: 0, y: 0 },
    };
  },
  mounted: function () {
    var scrollerConfig = {
      "//Description": "Default scroller with no configuration",
      touchSpeed: 1,
    };
    this.scroller = new Scroller("#articleScroller", scrollerConfig);
    this.count(0, this.$route.params.id, this.$route.params.issue);
    this.setShare();
    setInterval(()=>{
      this.bt1Animate=!this.bt1Animate
    },1500)
  },
  methods: {
    viewImage(e) {
      this.$store.commit("setImageSrc", e.target.src);
    },
    articleTouchMove(e) {
      e.preventDefault();
    },
    mainTouchStart(e) {
      this.touch.x = e.changedTouches[0].clientX;
      this.touch.y = e.changedTouches[0].clientY;
    },
    mainTouchEnd(e) {
      let p = parseInt(document.documentElement.style.fontSize);
      let x = (e.changedTouches[0].clientX - this.touch.x) / p;
      let y = Math.abs((e.changedTouches[0].clientY - this.touch.y) / p);
      if (x > 0.5 && y < 0.5) {
        // console.log(x, y)
        this.viewClass(this.$route.params.class - 1);
      }
    },
    returnPage: function () {
      if (pageStackStore.state.pageStack.length) {
        let url =
          pageStackStore.state.pageStack[
            pageStackStore.state.pageStack.length - 1
          ];
        pageStackStore.commit("unshiftPageStack");
        this.$router.replace(url);
      } else {
        this.viewClass(0);
      }
    },
    viewClass: function (key) {
      this.thisClass = key;
      pageStackStore.commit("pushPageStack", this.$route.path);
      this.$router.replace("/ArticleList/" + (key + 1));
    },
    count(isshare, id, issue) {
      let params = new URLSearchParams();
      params.append("id", id);
      params.append("issue", issue);
      params.append("isshare", isshare);
      let chanel = getQueryVariable("chanel");
      if (!chanel) chanel = 100;
      params.append("chanel", chanel);
      let isview = this.$cookies.get("isview_" + id + "_" + issue);
      if (isview) {
        params.append("isview", 1);
      } else {
        params.append("isview", 0);
        this.$cookies.set("isview_" + id + "_" + issue, 1, "1d");
      }

      this.axios
        .post("count.php", params)
        .then((response) => {
          // console.log(response.data)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setShare() {
      let shareData = {
        title: this.$store.state.ShareInfo.title,
        desc: this.$store.state.ShareInfo.desc,
        link: this.$store.state.ShareInfo.link,
        imgUrl: require("../assets/" + this.$store.state.ShareInfo.icon),
        success: function () {
          this.count(
            1,
            this.$store.state.ShareInfo.count,
            this.$store.state.ShareInfo.issue
          );
        }.bind(this),
      };
      wx.onMenuShareAppMessage(shareData);
      wx.onMenuShareTimeline(shareData);
    },
  },
  computed: {
    ScrollerStyle() {
      return {
        height: store.state.WindowSize.WindowHeightRem - 1.11 + "rem",
      };
    },
    ArticleContent() {
      return () =>
        import(
          "./" +
            this.$route.params.issue +
            "/Article" +
            this.$route.params.id +
            ".vue"
        );
    },
    viewImageSrc() {
      return this.$store.state.viewImageSrc;
    },
  },
};
</script>

<style lang="less" scoped>
@fullWidth: 11.25rem;
.fullWidhth {
  width: @fullWidth;
}

#article {
  .fullWidhth();

  height: 100%;
  background: #ffffff;

  #TopBTCotainer {
    .fullWidhth();

    height: 1.11rem;
    background: #ffffff;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 3;
    //border-top:.02rem solid #000000;
    box-shadow: 0px 0px 0.15rem 0.01rem #cccccc;
    //box-shadow: 0px .15rem .15rem .05rem rgba(100,100,100,.5);


    #TopBT1 {
      width: 1.26rem;
      margin-top: 0.35rem;
      margin-left: 0.9rem;
    }
    #TopBT2 {
      width: 0.5rem;
      margin-top: 0.38rem;
      margin-left: 7.69rem;
    }
    #TopBT3 {
      height: 0.45rem;
      float: right;
      margin-top: 0.33rem;
      margin-right: 0.9rem;
    }
    #TopBT4 {
      height: 0.45rem;
      float: right;
      margin-top: 0.33rem;
      margin-right: 0.9rem;
    }
  }

  #TopMenu {
    position: absolute;
    width: 1.77rem;
    top: 1.15rem;
    left: 8.58rem;
    z-index: 2;

    #TopMenuImg {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
    }
    #shareClickDiv {
      position: absolute;
      width: 1.77rem;
      height: 0.75rem;
      top: 0.3rem;
      left: 0rem;
    }
    #retrunClickDiv {
      position: absolute;
      width: 1.77rem;
      height: 0.75rem;
      top: 1.09rem;
      left: 0rem;
    }
  }
  #articleScroller {
    .fullWidhth();

    position: absolute;
    left: 0px;
    top: 1.11rem;

    #ArticleContainer {
      .fullWidhth();

      #ContentCotainer {
        width: 9.45rem;
        margin: 0.9rem;
      }
    }
  }
  #shareMasking {
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 20;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue